const LOGICAL_OPERATORS = new Set(['and', 'or', '!']);

const isLeafFilterExpression = (value: unknown[]): boolean => {
    if (value.length < 2) {
        return false;
    }

    const [, operator] = value;

    return typeof value[0] === 'string' && typeof operator === 'string' && !LOGICAL_OPERATORS.has(operator.toLowerCase());
};

const isFilterGroupOperator = (value: unknown) => {
    return typeof value === 'string' && (value.toLowerCase() === 'and' || value.toLowerCase() === 'or');
};

export const pruneDataGridFilterExpression = (filter: unknown, allowedFields: ReadonlySet<string>): unknown => {
    if (!Array.isArray(filter)) {
        return filter;
    }

    if (filter[0] === '!' && filter.length === 2) {
        const nestedFilter = pruneDataGridFilterExpression(filter[1], allowedFields);
        return nestedFilter ? ['!', nestedFilter] : undefined;
    }

    if (isLeafFilterExpression(filter)) {
        return allowedFields.has(filter[0].toLowerCase()) ? filter : undefined;
    }

    if (!Array.isArray(filter[0])) {
        return filter;
    }

    const result: unknown[] = [];
    let operator: string | undefined;

    filter.forEach((item) => {
        if (isFilterGroupOperator(item)) {
            operator = item;
            return;
        }

        const nestedFilter = pruneDataGridFilterExpression(item, allowedFields);
        if (!nestedFilter) {
            return;
        }

        if (result.length > 0) {
            result.push(operator ?? 'and');
        }

        result.push(nestedFilter);
        operator = undefined;
    });

    if (result.length === 0) {
        return undefined;
    }

    return result.length === 1 ? result[0] : result;
};

export const normalizeDataGridFilterExpression = (filter: unknown): unknown => {
    if (!Array.isArray(filter)) {
        return filter;
    }

    let normalized = filter.map((item) => normalizeDataGridFilterExpression(item));

    while (normalized.length === 1 && Array.isArray(normalized[0])) {
        normalized = normalized[0] as unknown[];
    }

    if (isLeafFilterExpression(normalized)) {
        return normalized;
    }

    const result: unknown[] = [];

    normalized.forEach((item) => {
        const previous = result[result.length - 1];

        if (Array.isArray(previous) && Array.isArray(item)) {
            result.push('and');
        }

        result.push(item);
    });

    return result;
};
